import { create } from "zustand";

type QuestionStore = {
  userQuestion: string;
  setQuestion: (question: string) => void;
  needToWriteQuestion: boolean;
  setNeedToWriteQuestion: (needToWriteQuestion: boolean) => void;
};

const useQuestionStore = create<QuestionStore>()((set) => ({
  userQuestion: "",
  setQuestion: (userQuestion) => set(() => ({ userQuestion })),
  needToWriteQuestion: false,
  setNeedToWriteQuestion: (needToWriteQuestion) =>
    set(() => ({ needToWriteQuestion })),
}));

export default useQuestionStore;
